import { render, staticRenderFns } from "./Outro.vue?vue&type=template&id=50a77cb6&"
import script from "./Outro.vue?vue&type=script&lang=js&"
export * from "./Outro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports